import PropTypes from 'prop-types';
import React from 'react';

const Subtitle = ({ text }) => {
  return <h2 className="text-light text-start mt-5 mb-4">{text}</h2>;
};

Subtitle.propTypes = {
  text: PropTypes.string.isRequired,
};

export default Subtitle;
